import React from 'react'


const FlagIcon = ({ type, size = 18, className = "" }) => {
  let fillColor = "none";
  let strokeColor = "#999";
  
  if (type === "red") {
    fillColor = "#ff4d4f";
    strokeColor = "#cf1322";
  } else if (type === "green") {
    fillColor = "#52c41a";
    strokeColor = "#389e0d";
  } else if (type === "empty") {
    fillColor = "none";
    strokeColor = "#999";
  }

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill={fillColor}
      stroke={strokeColor}
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={`flag-icon ${className}`}
    >
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
      <line x1="4" y1="22" x2="4" y2="15"/>
    </svg>
  );
};

export default FlagIcon;